import { TreeNode } from '../route-builder';

export const LoginModule = { segment: 'login' } as const satisfies TreeNode;
